<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Datos</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-4 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre componente</mat-label>
                        <input matInput formControlName="nombreComponente" autocomplete="off" [readonly]="true">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-4 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Dashboard (*)</mat-label>
                        <input matInput formControlName="dashboard" autocomplete="off">
                        <mat-error *ngIf="form.get('dashboard').hasError('required')">El Dashboard es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('dashboard').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Roles</span>
            </ng-template>
            <div class="mat-elevation-z8 p-0">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSourceRoles" matSort class="table table-striped table-hover">

                        <!-- id Column -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                        </ng-container>
                        <!-- rol Column -->
                        <ng-container matColumnDef="rol">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Rol </th>
                            <td mat-cell *matCellDef="let row"> {{row.rol}} </td>
                        </ng-container>
                        <!-- seleccionado Column -->
                        <ng-container matColumnDef="seleccionado">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                <mat-checkbox [(ngModel)]="seleccionarTodos" (ngModelChange)="SeleccionoTodos()">
                                    Asignado
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox [(ngModel)]="row.seleccionado">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columnasEncabezadoRoles"></tr>
                        <tr mat-row *matRowDef="let row; columns: columnasEncabezadoRoles;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="fondopaginador">
                <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>